import {useEffect} from "react";

const STORAGE_KEY = "clarity_consent";

export const sendClarityConsent = (granted) => {
    if (typeof window.clarity !== "function") return;
    const status = granted ? "granted" : "denied";
    window.clarity("consentv2", {
        ad_Storage: status,
        analytics_Storage: status,
    });
};

export const useClarityConsent = () => {
    useEffect(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved !== null) {
            sendClarityConsent(saved === "true");
        }
    }, []);

    const grant = () => {
        localStorage.setItem(STORAGE_KEY, "true");
        sendClarityConsent(true);
    };

    const deny = () => {
        localStorage.setItem(STORAGE_KEY, "false");
        sendClarityConsent(false);
    };

    const hasDecided = () => localStorage.getItem(STORAGE_KEY) !== null;

    return {grant, deny, hasDecided};
};
